import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Enquiry } from '../models/enquiry.model';

@Injectable({
  providedIn: 'root',
})
export class EnquiriesService {
  headers = {
    'Content-Type': 'application/json'
  };

  constructor(private http: HttpClient) {}

  sendEnquiry(enquiryData: Enquiry) {
    return this.http.post(environment.apiUrl + '/enquiries', enquiryData, {
      responseType: 'json',
      observe: 'body',
      headers: this.headers
    });
  }
}
